<template>
  <GenericProductPage 
    :productData="productData" 
    :customIntro="false">
  </GenericProductPage>
</template>

<script>
import GenericProductPage from '@/components/products/GenericProductPage.vue';
import ProductPageFactory from '@/factories/ProductPageFactory';
import productDataSource from '@/data/products';

export default {
  name: 'DynamicProductPage',
  components: {
    GenericProductPage
  },
  props: {
    productType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      productData: null
    };
  },
  watch: {
    productType: {
      immediate: true,
      handler(newValue) {
        this.loadProductData(newValue);
      }
    }
  },
  methods: {
    loadProductData(type) {
      // Check if we have predefined data for this product type
      if (productDataSource[type]) {
        // Use the predefined data
        this.productData = ProductPageFactory.createProduct(productDataSource[type]);
      } else {
        // Normalize the type to capitalize first letter and remove 'insurance' suffix
        const normalizedType = type.replace('insurance', '')
          .replace(/^\w/, c => c.toUpperCase());
        
        // Create default product data structure if no specific data exists
        this.productData = ProductPageFactory.createProduct({
          type: normalizedType
        });
      }
    }
  }
};
</script> 